import * as render from './render.pug'
import { onBeforeUnmount, onMounted, ref, reactive } from 'vue'
import { autoUpdate, computePosition, offset } from '@floating-ui/vue'

export const AvatarMenu = {
  ...render,
  props: {
    floating: {
      type: Object
    }
  },
  emits: [],
  components: { },
  directives: { },
  setup (props, { emit }) {
    const floating = ref(null)
    const floatingStyles = reactive({})

    onMounted(() => {
      const cleanup = autoUpdate(props.floating, floating.value, () => {
        computePosition(props.floating, floating.value, {
          placement: 'bottom-end',
          middleware: [
            offset(11)
          ]
        }).then(function ({ x, y }) {
          Object.assign(floatingStyles, {
            left: `${x}px`,
            top: `${y}px`
          })
        })
      })

      onBeforeUnmount(() => {
        cleanup()
      })
    })

    return {
      floating,
      floatingStyles
    }
  }
}
